var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 col-sm-12 d-flex justify-content-start" },
          [
            _vm.empresa
              ? _c(
                  "vx-card",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      title: "Mi empresa",
                      subtitle: _vm.empresa.fantasia
                    }
                  },
                  [
                    _c(
                      "vs-row",
                      [
                        _c("vs-col", { attrs: { "vs-w": "3" } }, [
                          _vm._v("Empresa")
                        ]),
                        _c(
                          "vs-col",
                          {
                            staticStyle: { "font-weight": "bolder" },
                            attrs: { "vs-w": "9" }
                          },
                          [_vm._v(_vm._s(_vm.empresa.fantasia))]
                        ),
                        _c("vs-col", { attrs: { "vs-w": "3" } }, [
                          _vm._v("RUT")
                        ]),
                        _c(
                          "vs-col",
                          {
                            staticStyle: { "font-weight": "bolder" },
                            attrs: { "vs-w": "9" }
                          },
                          [_vm._v(_vm._s(_vm.empresa.iut))]
                        ),
                        _c(
                          "vs-col",
                          { staticClass: "mt-3", attrs: { "vs-w": "3" } },
                          [_vm._v("Usuario")]
                        ),
                        _c(
                          "vs-col",
                          { staticClass: "mt-3", attrs: { "vs-w": "9" } },
                          [_vm._v(_vm._s(_vm.usuario.alias))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-lg-6 col-sm-12 d-flex justify-content-center",
            class: { "mt-5": _vm.product === "aprobacionesApp" }
          },
          [
            _c(
              "vx-card",
              {
                class: { "ml-2": _vm.product !== "aprobacionesApp" },
                attrs: { title: "Mis módulos" }
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "centrador" },
                    [
                      _vm._l(_vm.enabledModules, function(module) {
                        return _c(
                          "CheckPermission",
                          {
                            key: module.nombre,
                            staticClass: "modulo mr-5 mt-5 pt-5",
                            attrs: {
                              "data-cy": "module",
                              permission: module.permission
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.selectAndNavigateModule(module)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "nombre-modulo" }, [
                                  _vm._v(_vm._s(module.descripcion))
                                ]),
                                _c("vs-icon", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    icon: module.icono,
                                    size: "75px",
                                    color: "#ffffff"
                                  }
                                }),
                                module.nombre === _vm.moduloActual
                                  ? _c("vs-icon", {
                                      staticClass: "modulo-actual",
                                      attrs: {
                                        icon: "star",
                                        size: "20px",
                                        color: "#ffffff"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      _vm._l(_vm.disabledModules, function(module) {
                        return _c(
                          "CheckPermission",
                          {
                            key: module.nombre,
                            staticClass:
                              "modulo modulo-deshabilitado mr-5 mt-5 pt-5",
                            attrs: { permission: module.permission }
                          },
                          [
                            _c("div", { staticClass: "nombre-modulo" }, [
                              _vm._v(_vm._s(module.descripcion))
                            ]),
                            _c("vs-icon", {
                              staticClass: "mt-2",
                              attrs: {
                                icon: module.icono,
                                size: "75px",
                                color: "#ffffff"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "comunicado",
          attrs: {
            size: "lg",
            title: "Información importante",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            "hide-header-close": ""
          }
        },
        [_c("Comunicado", { on: { "close-comunicado": _vm.closeComunicado } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }